export interface LearningTask {
  id: string
  title: string
  description: string
  duration: string
  targetPath: string
}

export interface KnowledgeModule {
  id: string
  name: string
  status: '待诊断' | '学习中' | '待复习' | '已掌握'
  action: string
  description: string
}

export interface Assessment {
  id: string
  name: string
  scope: string
  duration: string
  status: '可开始' | '未解锁'
}

export const LEARNING_TASKS: readonly LearningTask[] = [
  {
    id: 'profile',
    title: '完善学生基础档案',
    description: '补充教材版本、数学单科成绩和暑假时间',
    duration: '预计 10 分钟',
    targetPath: '/today',
  },
  {
    id: 'diagnosis',
    title: '完成初高中衔接诊断',
    description: '定位运算、方程、不等式和函数基础断点',
    duration: '预计 40 分钟',
    targetPath: '/tutor',
  },
  {
    id: 'weekly-plan',
    title: '生成第一周学习计划',
    description: '诊断完成后，按真实结果安排每天任务',
    duration: '预计 10 分钟',
    targetPath: '/reports',
  },
] as const

export const KNOWLEDGE_MODULES: readonly KnowledgeModule[] = [
  {
    id: 'calculation',
    name: '运算基础',
    status: '待诊断',
    action: '完成衔接诊断',
    description: '数式运算、因式分解、分式与根式等高中学习底座。',
  },
  {
    id: 'equations',
    name: '方程与不等式',
    status: '待诊断',
    action: '完成衔接诊断',
    description: '方程组、一元二次方程、不等式求解与变形。',
  },
  {
    id: 'functions',
    name: '函数基础',
    status: '待诊断',
    action: '完成衔接诊断',
    description: '变量关系、图像、定义域、单调性与函数表达。',
  },
  {
    id: 'sets',
    name: '集合与逻辑',
    status: '待诊断',
    action: '确认教材版本',
    description: '集合表示、关系、基本运算和常用逻辑用语。',
  },
] as const

export const ASSESSMENTS: readonly Assessment[] = [
  {
    id: 'transition-diagnosis',
    name: '初高中衔接诊断',
    scope: '运算、方程、不等式、函数与表达',
    duration: '40 分钟',
    status: '可开始',
  },
  {
    id: 'unit-1',
    name: '首单元测评',
    scope: '待教材版本确认后生成',
    duration: '30 分钟',
    status: '未解锁',
  },
  {
    id: 'four-week',
    name: '四周阶段测评',
    scope: '对比入学基线与近期表现',
    duration: '60 分钟',
    status: '未解锁',
  },
] as const
